module.exports = __webpack_public_path__ + "img/expenses.f559a960.svg";